module.exports = __webpack_public_path__ + "img/nzavo-recipes.a5a5e92e.jpg";